import * as create from 'src/components/forms/schemas/patient/create';
import * as hrqol from 'src/components/forms/schemas/patient/hrqol';

export default { create, hrqol };
